<template>
  <div>
    <details-modal
      :show="modals.roleOffice"
      :current-operation="currentOperation"
      @cancel="closeModal"
      @create="createRecord"
      @delete="deleteRecord"
      @update="updateRecord"
    >
      <form>
        <fg-input v-model="roleOffice.roleofName" type="text" label="Nom" />
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          ref="crudList"
          :fetch-data="fetchRolesOffice"
          title="Rôles Bureaux"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom">
            <div slot-scope="slotScope">
              {{ slotScope.row.roleofName }}&nbsp;
            </div>
          </el-table-column>
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsModal from './Modals/DetailsModal.vue';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
    DetailsModal,
  },
  data() {
    return {
      modals: {
        roleOffice: false,
      },
      currentOperation: {},
      roleOffice: {},
      errorMessage: '',
    };
  },
  methods: {
    rowClicked(row) {
      this.currentOperation = 'edit';
      this.roleOffice = { ...row };
      this.modals.roleOffice = true;
    },
    fetchRolesOffice(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;

      if (searchText) {
        url += `/roleofficeEntities/search/fulltext?name=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/roleofficeEntities?page=${pageNumber - 1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.roleofficeEntities
          ? response.data._embedded.roleofficeEntities
          : [],
        page: response.data.page,
      }));
    },
    deleteRecord() {
      this.errorMessage = 'Deleting...';
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/rolesoffice/${this.roleOffice.roleofId}`,
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.roleOffice = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    updateRecord() {
      this.errorMessage = 'Updating...';
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/rolesoffice/${this.roleOffice.roleofId}`,
          {
            roleofName: this.roleOffice.roleofName,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.roleOffice = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    createRecord() {
      this.$http
        .post(`${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/rolesoffice/`, {
          roleofName: this.roleOffice.roleofName,
        })
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.roleOffice = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    create() {
      this.roleOffice = {};
      this.currentOperation = 'create';
      this.modals.roleOffice = true;
    },
    closeModal() {
      this.modals.roleOffice = false;
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped></style>
